import { useState, VFC } from "react";

import CargoGroupsOverviewView from "features/cargo-groups/views/CargoGroupsOverviewView";
import { FtlCargoGroupFormView } from "features/cargo-groups/views/FtlCargoGroupFormView";
import { useShipmentDetails } from "features/shipments/provider/ShipmentDetailsProvider";

const ShipmentDetailsCargoDetailsFtl: VFC = () => {
  const { patchedShipment, isEditing } = useShipmentDetails();
  const [expandedCargoGroupId, setExpandedCargoGroupId] = useState<number | false>(0);

  const hasCargoGroups = patchedShipment.trucks?.some((truck) => (truck.cargoGroups?.length ?? 0) > 0) ?? false;

  if (!hasCargoGroups) {
    return null;
  }

  if (isEditing) {
    return (
      <FtlCargoGroupFormView
        expanded={expandedCargoGroupId}
        onExpandChange={(index) => setExpandedCargoGroupId(index)}
      />
    );
  }

  return (
    <div className="px-4 py-2">
      <CargoGroupsOverviewView
        cargoGroups={patchedShipment.trucks?.flatMap((truck) => truck.cargoGroups ?? []) ?? []}
        variant="handlingUnit"
      />
    </div>
  );
};

export default ShipmentDetailsCargoDetailsFtl;
